<template>
	<div>
		<v-dialog v-model="dialog_uqc" no-click-animation scrollable persistent content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
	        	<v-subheader full-width>Select Unit Qty Code</v-subheader>
	        	<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-text full-height nopadding>

	        	<v-list nopadding>
		        	<v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="updateUqc(item)">

			            <v-list-tile-content>
			              <v-list-tile-title>{{item.name}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="item.id == selectedUqc">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>

		        	</v-list-tile>
		        </v-list>

		        <div class="display_msg" v-if="!filteredItems.length">No Items</div>

	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['unitQuantityCodes', 'selectedUqc', 'updateUqc'],
		data(){
			return{
				dialog_uqc: false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchValue = '';
				this.dialog_uqc = true;
			},
			closeDialogWeb: function () {
				this.dialog_uqc = false;
			},
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        if(this.unitQuantityCodes && this.unitQuantityCodes.length){
		        	return this.unitQuantityCodes.filter(item => {
			          let name = item.name.toLowerCase();
			          return name.match(searchText);
			        })	
		        }
		        else{
		        	return [];
		        }
		        
		    }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/units/dialogs/dialog_uqc.vue